import { AddressComponent } from './address/address.component';
import { AffidavitComponent } from './affidavit/affidavit.component';
import { AlwaysOpenWrapperComponent } from './always-open-wrapper/always-open-wrapper.component';
import { AnotherCompanyComponent } from './another-company/another-company.component';
import { BirthNumberAndBirthDateComponent } from './birthnumber-and-birth-date/birthNumber-and-birth-date.component';
import { ChangesSummaryComponent } from './changes-summary/changes-summary.component';
import { CheckboxDiscountComponent } from './checkbox-discount/checkbox-discount.component';
import { ChildrenComponent } from './children/children.component';
import { ErrorWrapperComponent } from './error-wrapper/error-wrapper.component';
import { ExecutionsComponent } from './executions/executions.component';
import { Executions2026Component } from './executions_2026/executions_2026.component';
import { FormlyFieldH2 } from './h2/h2.component';
import { Health2026Component } from './health-2026/health-2026.component';
import { HealthComponent } from './health/health.component';
import { IdCard2026Component } from './idcard-2026/idcard-2026.component';
import { IdCardComponent } from './idcard/idcard.component';
import { MonthDiscountComponent } from './month-discount/month-discount.component';
import { MonthSelecetComponent } from './month-select/month-select.component';
import { FormlyFieldMonthlySelect } from './month-select/month-select.field';
import { PartWrapperComponent } from './part-wrapper/part-wrapper.component';
import { PartnerComponent } from './partner/partner.component';
import { PersonalInfo2026Component } from './personal-2026/personal-2026.component';
import { PersonalInfoComponent } from './personal/personal.component';
import { Rezidentura2026Component } from './rezidentura-2026/rezidentura-2026.component';
import { RezidenturaComponent } from './rezidentura/rezidentura.component';
import { SummaryPersonal2026Component } from './summary-personal-2026/summary-personal-2026.component';
import { SummaryPersonalComponent } from './summary-personal/summary-personal.component';
import { SummaryTaxDeclaration2026Component } from './summary-tax-declaration-2026/summary-tax-declaration-2026.component';
import { SummaryTaxDeclarationComponent } from './summary-tax-declaration/summary-tax-declaration.component';
import { TipComponent } from './tip/tip.component';
import { WageComponent } from './wage/wage.component';
import { EmployeeCardWrapperComponent } from './wrapper/wrapper.component';

export const FORMLY_PARTS = [
  PersonalInfoComponent,
  TipComponent,
  MonthSelecetComponent,
  FormlyFieldMonthlySelect,
  FormlyFieldH2,
  AddressComponent,
  WageComponent,
  HealthComponent,
  IdCardComponent,
  AnotherCompanyComponent,
  ExecutionsComponent,
  RezidenturaComponent,
  Rezidentura2026Component,
  PersonalInfo2026Component,
  MonthDiscountComponent,
  ChildrenComponent,
  AffidavitComponent,
  CheckboxDiscountComponent,
  PartnerComponent,
  ChangesSummaryComponent,
  Health2026Component,
  SummaryPersonalComponent,
  SummaryPersonal2026Component,
  SummaryTaxDeclarationComponent,
  ErrorWrapperComponent,
  BirthNumberAndBirthDateComponent,
  IdCard2026Component,
  SummaryTaxDeclaration2026Component,
  Executions2026Component
];

export const FORMLY_TYPES = [
  {
    name: 'tip',
    className: 'p-col-12',
    component: TipComponent,
  },
  {
    name: 'h2',
    className: 'p-col-12',
    component: FormlyFieldH2,
  },
  {
    name: 'personal-info',
    component: PersonalInfoComponent,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'personal-info-2026',
    component: PersonalInfo2026Component,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'address',
    component: AddressComponent,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'wage',
    component: WageComponent,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'health',
    component: HealthComponent,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'health-2026',
    component: Health2026Component,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'idcard',
    component: IdCardComponent,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'idcard-2026',
    component: IdCard2026Component,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'anotherCompany',
    component: AnotherCompanyComponent,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'executions',
    component: ExecutionsComponent,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'executions-2026',
    component: Executions2026Component,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'rezidentura',
    component: RezidenturaComponent,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'rezidentura-2026',
    component: Rezidentura2026Component,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'month-discount',
    component: MonthDiscountComponent,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'checkbox-discount',
    component: CheckboxDiscountComponent,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'children',
    component: ChildrenComponent,
    wrappers: ['employee-card-wrapper'],
  },

  {
    name: 'affidavit',
    component: AffidavitComponent,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'partner',
    component: PartnerComponent,
    wrappers: ['employee-card-wrapper'],
  },

  {
    name: 'new-month-select',
    className: 'p-col-12',
    component: FormlyFieldMonthlySelect,
    wrappers: ['form-field'],
  },
  {
    name: 'changes-summary',
    className: 'p-col-12',
    component: ChangesSummaryComponent,
  },
  {
    name: 'summary-personal',
    component: SummaryPersonalComponent,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'summary-personal-2026',
    component: SummaryPersonal2026Component,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'summary-tax-declaration',
    component: SummaryTaxDeclarationComponent,
    wrappers: ['employee-card-wrapper'],
  },
  {
    name: 'summary-tax-declaration-2026',
    component: SummaryTaxDeclaration2026Component,
    wrappers: ['employee-card-wrapper'],
  },

  {
    name: 'birth-number-and-birth-date',
    component: BirthNumberAndBirthDateComponent,
    /*wrappers: ['employee-card-wrapper'],*/
  },
];

export const FORMLY_WRAPPER_DECLARATION = [
  EmployeeCardWrapperComponent,
  AlwaysOpenWrapperComponent,
  PartWrapperComponent,
];

export const FORMLY_WRAPPER = [
  {
    name: 'part-wrapper',
    component: PartWrapperComponent,
  },
  {
    name: 'employee-card-wrapper',
    component: EmployeeCardWrapperComponent,
  },
  {
    name: 'always-open-wrapper',
    component: AlwaysOpenWrapperComponent,
  },
  {
    name: 'error-wrapper',
    component: ErrorWrapperComponent,
  },

];
